
import React from 'react'
import { Box, CircularProgress } from '@mui/material'

function MiniLoader() {
  return (
    <>
    
    <Box sx={{
        height:'100%',
        width:'100%',
        zIndex:100,
        display:'flex',
        justifyContent:'center',
        alignItems:'center',
    }}
    >
        <Box>
            <CircularProgress/>
        </Box>
    </Box>
    
    </>
  )
}

export default MiniLoader